import React from 'react'
import LogsListing from '../../../../itrust_common/components/others/listings/LogsListing';
import CurrencyTypeView from '../../../../itrust_common/components/others/CurrencyTypeView';
import { getCardBrandImg, getPaymentMethodLabel, humanize } from '../../../../itrust_common/components/HelperFunctions';
import Moment from 'moment';
import { DatePicker } from 'react-widgets';
import { Field, FieldArray, reduxForm } from 'redux-form';
import { InputWithIcon } from '../../../../itrust_common/components/form';
import { onlyPositiveNumbers } from '../../../../itrust_common/components/form/FormValidations';
import { useCurrentTypeHook } from '../../../../itrust_common/components/others/helperHooks/useCurrentTypeHook';
import { connect, useDispatch } from 'react-redux';
import { orderPaymentCreate } from '../../../../redux/actions/order/orderPaymentActions';
import { formValueSelector } from 'redux-form';
import Alert from '../../../../itrust_common/components/Alert';
import DateFormatView from '../../../../itrust_common/components/others/DateFormatView';
import { orderLoad } from '../../../../redux/actions/order/orderActions';

const MyRenderForm = (props) => {
  const { fields, handleRefundAmount, currency, onlineRefund, activeMethod } = props
  return (
    <>
      {fields.map((member, index, members) => {
        return (
          <tr className="text-dark border-bottom border-light border-bottom-2">
            <td className="text-center">#{members.get(index).id}</td>
            <td>
              <CurrencyTypeView amount={members.get(index).amount} />
              {members.get(index).online_payment_details?.card_type && <span className='ml-5'>
                {getCardBrandImg(members.get(index).online_payment_details.card_type, 'mx-1')}
                {members.get(index).online_payment_details.last4digit}
              </span>}
            </td>
            <td>{getPaymentMethodLabel(members.get(index).mode_of_payment)}</td>
            <td className='min-width-11'>
              {['online', 'device', 'pay_by_text', 'link'].includes(activeMethod) ?
                <>
                  {(members.get(index).online_payment_details?.refund_details?.refund_at) &&
                    <span> {Moment(members.get(index).online_payment_details?.refund_details?.refund_at).format("YYYY/MM/DD")}</span>
                  }
                </> :
                <DateFormatView date={members.get(index).payment_date} />
              }
            </td>
            {(activeMethod === 'check' || activeMethod === '') &&
              <td>{members.get(index).check_details && members.get(index).check_details.check_number}</td>
            }
            {(activeMethod === 'card' || activeMethod === '') &&
              <td>{members.get(index).card_details && members.get(index).card_details.card_type}</td>
            }
            <td>
              {['online', 'device', 'pay_by_text', 'link'].includes(activeMethod) ?
                <>
                  {(members.get(index).online_payment_details?.refund_details?.charge_id) &&
                    <span>{members.get(index).staff_attributes?.name}</span>
                  }
                </> :
                <span>{members.get(index).staff_attributes?.name}</span>
              }
            </td>
            {!['online', 'device', 'pay_by_text', 'link'].includes(activeMethod) && <td>{members.get(index).notes}</td>}
            <td><CurrencyTypeView amount={members.get(index).refundable_amount} /></td>
            {!['online', 'device', 'pay_by_text', 'link'].includes(activeMethod) && <td>
              {(members.get(index).refundable_amount > 0 && !['online', 'device', 'pay_by_text', 'link'].includes(members.get(index).mode_of_payment)) ? <Field
                name={`payments[${index}][refund_amount]`}
                component={InputWithIcon}
                title={currency?.symbol}
                className="form-control"
                defaultValue={members.get(index).amount}
                validate={[onlyPositiveNumbers]}
              /> : ''}
            </td>}
            <td>
              {['online', 'device', 'pay_by_text', 'link'].includes(members.get(index).mode_of_payment) ?
                <>
                  {members.get(index).online_payment_details?.payment_intent_id ?
                    <>
                      {(members.get(index).online_payment_details?.refund_details?.charge_id || members.get(index).payment_type == 'refund') ?
                        <button type="button" className="btn btn-primary px-4 py-2 disabled">Refunded</button> :
                        <button type="button" className={`btn btn-outline-primary px-4 py-2`} onClick={() => onlineRefund(members.get(index))}>Refund</button>
                      }
                    </>
                    : ''
                  }
                </> :
                members.get(index).refundable_amount > 0 ? <button type="button" className={`btn btn-outline-primary px-4 py-2`} onClick={() => handleRefundAmount(index, members.get(index))}>Refund</button> : ''
              }
            </td>
          </tr>
        )
      })}
    </>
  )
}

function MakeRefundForm(props) {
  const { payments, LogsHead, activeMethod, dateFormatType, noShowMakeRefund, orderPaymentSaving, onlineRefund, handlePaymentSubmit, orderId, paymentsFormValues, user } = props
  const currency = useCurrentTypeHook();
  const dispatch = useDispatch()

  const handleRefundAmount = async (index, member) => {
    const amount = paymentsFormValues?.[index]?.refund_amount
    if (amount) {
      const data = {
        parent_payment_id: member.id,
        amount: amount,
        payment_type: 'refund',
        orders_order_id: orderId,
        mode_of_payment: member.mode_of_payment,
        payment_date: Moment(new Date()).format("YYYY/MM/DD"),
        staff_id: user.id,
        card_details: member.card_details,
        check_details: member.check_details,
      }
      await dispatch(orderPaymentCreate(orderId, data))
      dispatch(orderLoad(orderId, { include: '*' }))
    }
    else {
      Alert.warning('Please enter refund amount.')
    }

  }

  return (
    <div className='px-2 height-50 overflow-auto' style={{ minHeight: '24rem' }}>
      <form>
        <LogsListing
          logs={payments}
          TableHead={LogsHead}
          // TableBody={MyForm}
          loading={orderPaymentSaving}
          tableClasses="thead-0"
        >
          {payments.length ?
            <FieldArray name="payments" component={MyRenderForm} props={{
              currency: currency,
              handleRefundAmount: handleRefundAmount,
              orderId: orderId,
              onlineRefund: onlineRefund,
              activeMethod: activeMethod,
              dispatch: dispatch
            }} /> :
            <tr>
              <td colSpan={14} className='text-center font-size-18'>No Record Found</td>
            </tr>
          }
        </LogsListing>
      </form>
    </div>
  )
}

const selector = formValueSelector('MakeRefundForm');

MakeRefundForm = reduxForm({
  form: 'MakeRefundForm',
  enableReinitialize: true
})(MakeRefundForm);

const mapStateToProps = (state) => {
  const { order: { order }, auth: { user } } = state
  return {
    orderId: order.id,
    user,
    paymentsFormValues: selector(state, 'payments')
  }
}

export default connect(mapStateToProps)(MakeRefundForm);